var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDocWord = function SvgIcDocWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.333 33V106.667C113.333 114 107.333 120 99.9993 120H19.9993C12.666 120 6.66602 114 6.66602 106.667V13.3333C6.66602 6 12.666 0 19.9993 0H80.3327L113.333 33Z",
    fill: "#4F6BF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1172 88.5502H75.0739L86.6672 51.4502H79.7139L68.1172 88.5502Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.334 26.3333V0L113.334 33H87.0007C83.334 33 80.334 30 80.334 26.3333Z",
    fill: "#243EBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.074 88.5502H68.1173L56.524 56.0869H63.4773L75.074 88.5502ZM51.884 88.5502H44.9273L33.334 51.4502H40.2873L51.884 88.5502Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9258 88.5502H51.8824L63.4758 56.0869H56.5224L44.9258 88.5502Z",
    fill: "white"
  })));
};
export default SvgIcDocWord;